import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  updateShipmentDataThunk
} from "../../store/features/shipmentsSlice";
import {updateMandatoryDataThunk ,fetchDocumentsByCase} from "../../store/features/documentSlice";
import SuccessMessageBox from "../Notification/Success";
import { createDraftEmail } from "../../store/features/emailsSlice";

const ShipmentInfo = ({ dataTemplate, threadId,documentId}) => {
  
function cleanDataTemplate(dataTemplate) {
    const cleanedData = {};

    for (const category in dataTemplate) {
        cleanedData[category] = {};
        for (const key in dataTemplate[category]) {
            // Only keep the "Value" field
            cleanedData[category][key] = dataTemplate[category][key].Value;
        }
    }

    return cleanedData;
}
  const email = "supplychain@linear-works.com";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const simulate_data = {

        "Origin": {
            "ArrivalDate": {
                "Value": "2024-10-01",
                "Mandatory": true,
                "SourceFile": "AWB"
            },
            "Airwaybill Number": {
                "Value": "42 2163 8315",
                "Mandatory": true,
                "SourceFile": "AWB"
            },
            "ShipNameFlightNumber": {
                "Value": "Flight XYZ123",
                "Mandatory": true,
                "SourceFile": "AWB"
            },
            "PortOfDespatchArrival": {
                "Value": "QU EBEC QC Canada",
                "Mandatory": true,
                "SourceFile": "CI"
            }
        },
        "Various": {
            "EndUser": {
                "Value": "Leonardo UK Ltd.",
                "Mandatory": true,
                "SourceFile": "CCI"
            },
            "Priority": {
                "Value": "Standard",
                "Mandatory": false,
                "SourceFile": ""
            },
            "NetWeight": {
                "Value": "0.02",
                "Mandatory": true,
                "SourceFile": "CI"
            },
            "PartNumber": {
                "Value": "PN-12345",
                "Mandatory": true,
                "SourceFile": "CI"
            },
            "GrossWeight": {
                "Value": "0.5",
                "Mandatory": true,
                "SourceFile": "AWB"
            },
            "NoOfPackages": {
                "Value": "1",
                "Mandatory": true,
                "SourceFile": "AWB"
            },
            "HazardousGoods": {
                "Value": "No",
                "Mandatory": true,
                "SourceFile": "CCI"
            },
            "PartNumberValue": {
                "Value": "2,330.00",
                "Mandatory": true,
                "SourceFile": "CI"
            },
            "ProjectPlatform": {
                "Value": "Project Alpha",
                "Mandatory": true,
                "SourceFile": "CCI"
            },
            "ProhibitedWeapon": {
                "Value": "No",
                "Mandatory": true,
                "SourceFile": "CCI"
            },
            "IncotermNamedPlace": {
                "Value": "DDP (Delivered Duty Paid)",
                "Mandatory": true,
                "SourceFile": "CCI"
            },
            "PartNumberCurrency": {
                "Value": "USD",
                "Mandatory": true,
                "SourceFile": "CI"
            },
            "PartNumberDescription": {
                "Value": "DTGS Detector with AR coated ZnSe window",
                "Mandatory": true,
                "SourceFile": "CI"
            },
            "PartNumberRepairValue": {
                "Value": "***NOT SOLD -RETURN FOR REPAIR***",
                "Mandatory": false,
                "SourceFile": ""
            },
            "PartNumberSerialNumber": {
                "Value": "SN-987654",
                "Mandatory": false,
                "SourceFile": ""
            },
            "HarmonisedCommodityCode": {
                "Value": "9031.90 GB",
                "Mandatory": true,
                "SourceFile": "CI"
            },
            "PartNumberCountryOfOrigin": {
                "Value": "Canada",
                "Mandatory": true,
                "SourceFile": "CI"
            }
        },
        "Originator": {
            "Department": {
                "Value": "Logistics",
                "Mandatory": false,
                "SourceFile": ""
            },
            "ContactName": {
                "Value": "John Doe",
                "Mandatory": false,
                "SourceFile": ""
            },
            "PhoneNumber": {
                "Value": "+1-123-456-7890",
                "Mandatory": false,
                "SourceFile": ""
            },
            "EmailAddress": {
                "Value": "john.doe@example.com",
                "Mandatory": false,
                "SourceFile": ""
            },
            "PurchaseOrderNumber": {
                "Value": "PO-67890",
                "Mandatory": true,
                "SourceFile": "CI"
            }
        },
        "DeliveryPoint": {
            "ContactName": {
                "Value": "Jane Smith",
                "Mandatory": false,
                "SourceFile": ""
            },
            "CompanyNameAddress": {
                "Value": "Somewhere, UNITED KINGDOM",
                "Mandatory": true,
                "SourceFile": "CI"
            }
        },
        "ShipperExporterSupplier": {
            "ContactName": {
                "Value": "Michael Brown",
                "Mandatory": false,
                "SourceFile": ""
            },
            "PhoneNumber": {
                "Value": "+1-987-654-3210",
                "Mandatory": false,
                "SourceFile": ""
            },
            "EmailAddress": {
                "Value": "michael.brown@example.com",
                "Mandatory": false,
                "SourceFile": ""
            },
            "CompanyNameAddress": {
                "Value": "QU EBEC QC Canada",
                "Mandatory": true,
                "SourceFile": "CI"
            }
        }
}
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const { thread_id, case_number, documents, emailBodies} = shipment;
  const [data, setData] = useState(dataTemplate); // Editable data state
  const [isComplete, setIsComplete] = useState(false); // Save button state
  const [isClean, setIsClean] = useState(false); // Track if data has been cleaned
  console.log("data template",dataTemplate)
  console.log("simulate data",simulate_data)
  const cleanedData = cleanDataTemplate(simulate_data); // Clean the data template

  useEffect(() => {
    if (!isClean) { // Only set data if it hasn't been cleaned yet
      setData(cleanedData);
      setIsClean(true); // Mark the data as cleaned
    }
  }, [isClean]);

  // Check if all fields are filled
  useEffect(() => {
    const checkCompletion = (obj) => {
      for (let key in obj) {
        if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
          if (!checkCompletion(obj[key])) return false;
        } else if (obj[key] === "" || obj[key] === "N/A") {
          return false;
        }
      }
      return true;
    };

    setIsComplete(checkCompletion(data));
  }, [data]);

  const handleCreateDraft = async () => {
    await dispatch(createDraftEmail({ caseNumber:case_number, replyText: "Draft email sending clearance instruction", email}));
  };


  
  const handleCreateInstruction = () => {
    try {
        // handleSave(); // Call save function
        setShowSuccessMessage(true); // Show success popup
        handleCreateDraft();//Create draft email
        setTimeout(() => setShowSuccessMessage(false), 3000);// Automatically hide the message after 3 seconds
    } catch (error) {
        console.error("Failed to save amends:", error);
        alert("Failed to save amends. Please try again.");
    }
    navigate(`/dashboard/instruction/${threadId}/3`);
  };

  // Handle input changes
  const handleChange = (path, value) => {
    const keys = path.split(".");
    const updatedData = { ...data }; // Create a shallow copy of the root object
  
    let ref = updatedData;
  
    // Traverse the nested structure immutably
    keys.forEach((key, idx) => {
      if (idx === keys.length - 1) {
        // Update the final key with the new value
        ref[key] = value;
      } else {
        // Ensure intermediate objects are cloned immutably
        ref[key] = { ...ref[key] };
        ref = ref[key];
      }
    });
  
    // Update the state with the new object
    setData(updatedData);
  };

  // Recursive rendering of fields
  const renderFields = (obj, path = "") => {

    const formatKey = (key) => {
      return key
        // Add a space before uppercase letters not preceded by another uppercase letter
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        // Add a space between consecutive uppercase letters followed by lowercase letters
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
        // Capitalize the first letter
        .replace(/^./, (str) => str.toUpperCase());
    };
    return Object.keys(obj).map((key) => {
      const currentPath = path ? `${path}.${key}` : key;
      const value = obj[key];

      if (typeof value === "object" && !Array.isArray(value)) {
        return (
          <div key={currentPath} className="mb-6 border p-4 rounded bg-gray-50">
            <h4 className="font-bold text-gray-700 mb-2">{formatKey(key)}</h4>
            <div className="grid grid-cols-2 gap-4 ml-4">
              {renderFields(value, currentPath)}
            </div>
          </div>
        );
      } else if (Array.isArray(value)) {
        return (
          <div key={currentPath} className="mb-6">
            <h4 className="font-bold text-gray-700 mb-2">{formatKey(key)}</h4>
            {value.map((item, idx) => (
              <div
                key={`${currentPath}[${idx}]`}
                className="mb-4 border p-4 rounded bg-gray-50"
              >
                <h5 className="font-bold text-gray-600">Item {idx + 1}</h5>
                <div className="grid grid-cols-2 gap-4 ml-4">
                  {renderFields(item, `${currentPath}[${idx}]`)}
                </div>
              </div>
            ))}
          </div>
        );
      } else {
        const isIncomplete = value === "" || value === "N/A";
        return (
          <div key={currentPath} className="mb-4">
            <label className="block text-gray-600 mb-1">{formatKey(key)}</label>
            <input
              type="text"
              value={`${
                isIncomplete ? "Demo Data" : value
              }`}
              onChange={(e) => handleChange(currentPath, e.target.value)}
              className={`w-full p-2 border rounded ${
                isIncomplete ? "border-red-500 bg-red-50" : "border-gray-300"
              }`}
              placeholder={`Enter ${key}`}
            />
          </div>
        );
      }
    });
  };
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); // State for success message visibility
  const handleSave = async () => {
      // Dispatch Redux actions to update the filled data template and persist globally
      await dispatch(updateMandatoryDataThunk({ caseNumber:case_number, documentId, extractedInfo:data }));
      console.log("updated data",data)
    };

  // Handle Save Function
  const handleSaveClick = async () => {
    try {
        await handleSave(); // Call save function
        setShowSuccessMessage(true); // Show success popup

        // Automatically hide the message after 3 seconds
        setTimeout(() => setShowSuccessMessage(false), 3000);
    } catch (error) {
        console.error("Failed to save amends:", error);
        alert("Failed to save amends. Please try again.");
    }
};


  return (
        <div className="relative bg-bg p-1 flex border rounded-md border-border-document flex-col h-full">
            {/* Rendering Area */}
            <div className="flex-grow overflow-y-auto m-2 p-1 bg-bg">
                <h3 className="font-bold text-lg mb-4">Shipment Registration Table</h3>
                {/* Render data fields */}
                {renderFields(data)}
            </div>

            {/* Fixed Footer Area (OUTSIDE Scrolling Section) */}
            <div className="flex justify-end items-center pb-2 pr-2 bg-white">
                {/* Save Amends Button with Tooltip */}
                <div className="relative group gap"> 

                    <button
                        onClick={handleCreateInstruction}
                        // disabled={!isComplete}
                        className={`px-4 p-2 text-logo rounded-full transition-all ${
                            isComplete
                                ? 'bg-bg border border-logo text-logo hover:bg-logo hover:text-white'
                                : 'bg-bg border border-logo cursor-not-allowed'
                        }`}
                    >
                       Save and Create Clearance Instruction
                    </button>

                    {/* Tooltip - Appears only when button is disabled */}
                    {/* {!isComplete && (
                        <div
                            className="fixed z-50 pb-4 p-2 text-sm text-white bg-gray-800 rounded-md shadow-lg hidden group-hover:block"
                            style={{
                                top: 'calc(100% - 150px)', // Adjust this to position it above the button
                                right: '50px', // Keeps it aligned to the right corner
                                width: '300px',
                            }}
                        >
                            Please fill all required fields.
                            If information is unavailable, proceed to send the draft email.
                        </div>
                    )} */}
                </div>
            </div>

            {/* Success Message Popup */}
            {showSuccessMessage && (
                <SuccessMessageBox
                  message="Shipment registration info successfully updated"
                />
            )}
        </div>
  );
};

export default ShipmentInfo;
